import { render, staticRenderFns } from "./NoVoltageReference.UK.1.vue?vue&type=template&id=39430020&scoped=true"
import script from "./NoVoltageReference.UK.1.vue?vue&type=script&lang=js"
export * from "./NoVoltageReference.UK.1.vue?vue&type=script&lang=js"
import style0 from "./NoVoltageReference.UK.1.vue?vue&type=style&index=0&id=39430020&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39430020",
  null
  
)

export default component.exports